export default __webpack_public_path__ + "static/media/CAR_T_cell_manufacturing_workflow_2500.28bb6fb4.png";